import React from "react";

// Renders [text](url) links inside a line.
const withLinks = (line) =>
  line.split(/(\[[^\]]+\]\([^)\s]+\))/g).map((part, i) => {
    const m = part.match(/^\[([^\]]+)\]\(([^)\s]+)\)$/);
    return m ? (
      <a key={i} href={m[2]} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
        {m[1]}
      </a>
    ) : (
      part
    );
  });

const isHeading = (line) => /[A-Z]/.test(line) && line === line.toUpperCase() && line.length < 60;

// Simple format: CAPITALS line = heading, "- " = bullet, [text](link) = link; {year}/{fee} filled in.
export const DeclarationText = ({ text, year, fee }) => {
  const filled = (text || "").replace(/\{year\}/g, year ?? "").replace(/\{fee\}/g, fee ?? "");
  return (
    <div className="space-y-3 text-sm text-gray-700 leading-relaxed" data-testid="membership-declaration-text">
      {filled.split("\n").map((raw, i) => {
        const line = raw.trim();
        if (!line) return null;
        if (line.startsWith("- ")) {
          return <p key={i} className="ml-4">• {withLinks(line.slice(2))}</p>;
        }
        if (isHeading(line)) {
          return <p key={i} className="font-semibold text-blue-900 pt-2">{line}</p>;
        }
        return <p key={i}>{withLinks(line)}</p>;
      })}
    </div>
  );
};
